import { render, staticRenderFns } from "./Flight.vue?vue&type=template&id=616ba9e6&scoped=true&"
import script from "./Flight.vue?vue&type=script&lang=js&"
export * from "./Flight.vue?vue&type=script&lang=js&"
import style0 from "./Flight.vue?vue&type=style&index=0&id=616ba9e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616ba9e6",
  null
  
)

export default component.exports